import React, { useState, useEffect } from "react";
import Header from "components/Headers/Header.js";
import { useHistory } from "react-router-dom";
import { Card, CardHeader, Table, Container, Row, Input } from "reactstrap";
import {
  BANNER_IMAGE_API,
  DELETE_BANNER_IMAGE_API,
  UPDATE_BANNER_IMAGE_API,
} from "../../services/CONSTANTS";
import {
  getApiDataService,
  deleteApiDataService,
  postApiImageUploadService,
  putApiDataService,
} from "../../services/apiServices";
import { ConfirmDialog, FilterBar } from "components/shared";
import CreateBannerModal from "./banner/CreateBannerImageModal";

function BannerImage() {
  const history = useHistory();
  const [banner, setBanner] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [item, setitem] = useState(null);

  useEffect(() => {
    fetchBanner();
  }, []);

  const handleCreateClick = () => {
    console.log("Create item");
    setShowCreateModal(true);
  };

  const handleDeleteClick = (item) => {
    console.log("Delete item", item);
    setitem(item);
    setShowDeleteModal(true);
  };

  const fetchBanner = () => {
    setIsLoading(true);
    getApiDataService(BANNER_IMAGE_API)
      .then((res) => {
        setBanner(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setIsLoading(false);
        setBanner(null);
      });
    return () => {
      console.log("axios cleanup.");
    };
  };

  const handleDeleteConfirm = () => {
    setIsLoading(true);
    console.log("Deleting item", item.id);
    deleteApiDataService(DELETE_BANNER_IMAGE_API(item.id))
      .then((res) => {
        console.log("Delete success", res);
        setShowDeleteModal(false);
        fetchBanner();
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error in delete!", err);
        setIsLoading(false);
      });
  };

  const handleModalBoxCancel = () => {
    setShowDeleteModal(false);
    setShowCreateModal(false);
  };

  const handleCreateSubmit = (data) => {
    console.log("data", data);
    setIsLoading(true);
    postApiImageUploadService(BANNER_IMAGE_API, data)
      .then((res) => {
        console.log(res);
        setIsLoading(false);
        setShowCreateModal(false);
        fetchBanner();
      })
      .catch((err) => {
        console.log("Error in handleCreateSubmit!", err);
        setIsLoading(false);
      });
  };

  const handleBannerChange = (e, id) => {
    if (
      e.target.files[0].type === "image/jpeg" ||
      e.target.files[0].type === "image/png" ||
      e.target.files[0].type === "image/jpg"
    ) {
      let imgReview = e.target.files[0];
      console.log("id", id);
      let image = e.target.files[0];
      let form_data = new FormData();
      form_data.append("image", image);
      putApiDataService(UPDATE_BANNER_IMAGE_API(id), form_data)
        .then((res) => {
          console.log(res);
          setIsLoading(false);
          fetchBanner();
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("Error in handleUpdateSubmit!", err);
        });
    } else {
      alert("This is only accept image files! Thanks");
      return;
    }
  };

  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <FilterBar title="Banner Image">
                  <button
                    onClick={() => handleCreateClick()}
                    className="btn btn-sm btn-primary"
                  >
                    Create
                  </button>
                </FilterBar>
              </CardHeader>
              {banner?.length !== 0 ? (
                <>
                  {banner?.map((item, index) => (
                    <div
                      key={item.id}
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        alignItems: "center",
                        margin: "5px",
                      }}
                    >
                      <label htmlFor={"banner_img" + item.id}>
                        <img
                          src={item?.image}
                          alt="Banner"
                          style={{
                            width: "300px ",
                            height: "150px",
                            borderRadius: "5px",
                          }}
                        />
                      </label>
                      <Input
                        type="file"
                        id={"banner_img" + item.id}
                        accept="image/jpeg, image/png, image/jpg"
                        name="name"
                        style={{display:'none'}}
                        onChange={(e) => handleBannerChange(e, item.id)}
                      />
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDeleteClick(item)}
                      >
                        Delete
                      </button>{" "}
                    </div>
                  ))}
                </>
              ) : null}
            </Card>
          </div>
        </Row>
      </Container>
      {showDeleteModal && (
        <ConfirmDialog
          isOpen
          toggle={handleModalBoxCancel}
          title="Delete"
          message="Are you sure you want to delete this item?"
          confirmText="Yes"
          confirmColor="danger"
          isLoading={isLoading}
          onConfirm={handleDeleteConfirm}
        />
      )}
      {showCreateModal && (
        <CreateBannerModal
          onClose={handleModalBoxCancel}
          onSubmit={handleCreateSubmit}
        />
      )}
    </>
  );
}

export default BannerImage;
